module.exports = __webpack_public_path__ + "img/gtm.ea759f4e.png";